import Vue from 'vue';
import './core';
import './components/ui';
import './components';
import router from './router';
import App from './App.vue';
import store from './store'
import Notifications from 'vue-notification';

Vue.use(Notifications);

Vue.config.productionTip = false;

//import JuniorStudentCabinet from './junior-student-cabinet';

new Vue({
    router,
    store,
    render: h => h(App)
    //render: h => h(JuniorStudentCabinet),
}).$mount('#app');
